import { FONT_SIZES } from "../const/baseTheme";
/**
 * Calculates the font size for the footer buttons
 *
 * @param isOnlyOneButtonPresent boolean indicating only one button is available for the footer
 * @param isDropdownItem Optional boolean indicating a button is part of a dropdown
 * @returns string px value 14px for dropdown items or if only one button present, multiple buttons is 12px
 */
var calculateFontSizeforFooterButtons = function (isOnlyOneButtonPresent, isDropdownItem) {
    return isOnlyOneButtonPresent || isDropdownItem
        ? "".concat(FONT_SIZES.smallRoot, "px")
        : "".concat(FONT_SIZES.small, "px");
};
export default calculateFontSizeforFooterButtons;
//# sourceMappingURL=calculateFontSizeforFooterButtons.js.map